<template>
  <!--PUT HTML HERE-->
  <div>
    <div
      class="col-xs-12 right-container"
      :class="{ isStudent: auth.user().role == 'Student' }"
    >
      <!-- v-shortkey="{
        up: ['arrowup'],
        down: ['arrowdown'],
        left: ['arrowleft'],
        right: ['arrowright'],
        enter: ['enter'],
      }"
      @shortkey="listingAccessibility" -->

      <kr-search
        name="activities_listing"
        :url="{ url: '/student/tests' }"
        :options="{
          trash_field: false,
          search_field: false,
          thead: false,
          top_bar: false,
          table_background: false,
          table_tabs: true,
          query_fields: query_fields,
        }"
        @retrieveData="getTestData"
        class="overflowXinherit"
      >
        <!-- <template slot="top-display-from-to" slot-scope="props">
                    <div class="displayNo">
                        {{props.model.from}} - {{props.model.to}} of {{props.model.meta.paginator.total}}
                    </div>
                </template> -->

        <template slot="tabs" v-if="false">
          <div class="stepsNaviFixed nav-tabsContainer">
            <div class="links">
              <ul>
                <li
                  :class="{ active: query_fields.isArchived == 0 }"
                  @click="
                    query_fields.isArchived = 0;
                    searchModule();
                  "
                  @keyup.enter="
                    query_fields.isArchived = 0;
                    searchModule();
                  "
                >
                  <a
                    class="nav-link"
                    :class="{ active: query_fields.isArchived == 0 }"
                    id="Active-tab"
                    data-toggle="tab"
                    href=""
                    role="tab"
                    aria-controls="Active"
                    aria-selected="true"
                  >
                    Active
                  </a>
                </li>
                <li
                  :class="{ active: query_fields.isArchived == 1 }"
                  @click="
                    query_fields.isArchived = 1;
                    searchModule();
                  "
                  @keyup.enter="
                    query_fields.isArchived = 1;
                    searchModule();
                  "
                >
                  <a
                    class="nav-link"
                    :class="{ active: query_fields.isArchived == 1 }"
                    id="Archived-tab"
                    data-toggle="tab"
                    href=""
                    role="tab"
                    aria-controls="Archived"
                    aria-selected="true"
                  >
                    Archived
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </template>

        <template slot="table-title" slot-scope="props">
          <div class="d-block marginTop20">
            <!-- <th colspan="12">
              <template v-if="query_fields.isArchived == 0">Active</template
              ><template v-else>Archived</template> Activities (
              {{ props.model.from }} - {{ props.model.to }} of
              {{ props.model.meta.paginator.total }} )
            </th> -->

            <div class="tab-buttons">
              <div
                class="button mainBtn"
                :class="{ active: query_fields.isArchived == 0 }"
                style="cursor: pointer"
                @click="
                  query_fields.isArchived = 0;
                  searchModule();
                "
              >
                Active
              </div>
              <div
                class="button mainBtn"
                :class="{ active: query_fields.isArchived == 1 }"
                style="cursor: pointer"
                @click="
                  query_fields.isArchived = 1;
                  searchModule();
                "
              >
                Archived
              </div>
            </div>
          </div>
        </template>
        <template slot="ndata" slot-scope="props">
          <table class="table bt-0">
            <tbody>
              <tr>
                <td class="text-center">
                  <!-- No
                  <template v-if="query_fields.isArchived == 0">Active</template
                  ><template v-else>Archived</template> Activity -->
                  <template
                    v-if="testSearchData.data.settings.defaultMessagesSettings"
                  >
                    <kr-math
                      :input="
                        testSearchData.data.settings.defaultMessagesSettings
                      "
                    >
                    </kr-math>
                  </template>
                  <template v-else>
                    Please be patient. Your activities will appear once your
                    instructors have published them.
                  </template>
                </td>
              </tr>
            </tbody>
          </table>
        </template>
        <template slot="newData" slot-scope="props">
          <div
            v-for="(module, idx) in testSearchData.data.data"
            class="table-responsive new-studentTest-index-table"
            :key="'module-' + module.uuid"
          >
            <table class="table">
              <thead>
                <caption class="visible-hidden">
                  Course Name
                  {{
                    module.courseName
                  }}
                  {{
                    module.courseCode ? `(${module.courseCode})` : ""
                  }}
                  Module Name
                  {{
                    module.name
                  }}
                </caption>

                <tr class="test-customize-header borderNone" aria-hidden="true">
                  <th colspan="12" class="borderNone">
                    <h3>{{ module.name }}</h3>
                    <h4>
                      {{ module.courseName }}
                      {{ module.courseCode ? `(${module.courseCode})` : "" }}
                    </h4>
                  </th>
                </tr>
                <tr>
                  <th class="hidden-xs hidden-sm" style="width: 170px">Type</th>
                  <th class="hidden-md hidden-lg" style="width: 142px">
                    Type & Status
                  </th>
                  <th
                    class="hidden-xs hidden-sm"
                    style="width: calc(100% - 170px - 155px - 500px)"
                  >
                    Name
                  </th>
                  <th
                    class="hidden-md hidden-lg"
                    style="width: calc(100% - 142px - 285px)"
                  >
                    Name
                  </th>
                  <th class="hidden-xs hidden-sm" style="width: 155px">
                    Status
                  </th>
                  <th class="hidden-xs hidden-sm" style="width: 500px;">
                    Actions
                  </th>
                  <th class="hidden-md hidden-lg" style="width: 285px">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-for="activity in module.activities">
                  <tr
                    v-for="(model, idx) in activity.tests"
                    :key="'tbody_' + model.uuid"
                    class="test-listing-row"
                  >
                    <td>
                      <div class="hidden-xs hidden-sm">
                        <template v-if="model.type == 'prework'">
                          Prework
                        </template>
                        <template v-if="model.type == 'irat'">
                          IRAT
                        </template>
                        <template v-if="model.type == 'trat'">
                          TRAT
                        </template>
                        <template v-if="model.type == 'iratntrat'">
                          IRAT & TRAT
                        </template>
                        <template v-if="model.type == 'application'">
                          Application Case
                        </template>
                        <template v-if="model.type == 'evaluation'">
                          360 Degree Evaluation
                        </template>
                        <template v-if="model.type == 'michaelsenEvaluation'">
                          Peer Evaluation: Michaelsen’s Method
                        </template>
                      </div>

                      <div class="hidden-md hidden-lg">
                        <div class="borderGrey fontSize12" aria-hidden="true">
                          <template v-if="model.type == 'prework'">
                            Prework
                          </template>
                          <template v-if="model.type == 'irat'">
                            IRAT
                          </template>
                          <template v-if="model.type == 'trat'">
                            TRAT
                          </template>
                          <template v-if="model.type == 'iratntrat'">
                            IRAT & TRAT
                          </template>
                          <template v-if="model.type == 'application'">
                            Application
                          </template>
                          <template v-if="model.type == 'evaluation'">
                            360 Degree Evaluation
                          </template>
                          <template v-if="model.type == 'michaelsenEvaluation'">
                            Peer Evaluation: Michaelsen’s Method
                          </template>
                        </div>

                        <test-status
                          class="marginTop20"
                          :test="model"
                          role="student"
                        ></test-status>
                      </div>
                    </td>

                    <td>
                      <p>
                        {{ activity.name }}
                        <template
                          v-if="model.settings.allowSafeExamBrowserOnly"
                        >
                          (Safe Exam Browser Only)
                        </template>
                      </p>
                    </td>

                    <td class="hidden-xs hidden-sm">
                      <test-status :test="model" role="student"></test-status>
                    </td>
                    <td class="td-btn">
                      <!-- <div class="buttonGroupInline hidden-xs hidden-sm">
                        <router-link
                          v-if="model.type != 'prework'"
                          :to="{
                            name: 'tests.instruction',
                            params: {
                              id: model.testStudent.uuid,
                            },
                          }"
                          tag="button"
                          class="btn btn-outline-default"
                          aria-label="Instructions"
                        >
                          <i class="fas fa-book marginRight8"></i>Instructions
                        </router-link>
                        <button
                          v-if="
                            [
                              'not started',
                              'scheduled',
                              'ongoing',
                              'paused',
                            ].includes(model.status) &&
                              !isTestCompleted(model) &&
                              model.type != 'prework'
                          "
                          class="btn btn-success"
                          @click="openLoadingModal(model)"
                          :disabled="lapsed"
                          :aria-label="'row ' + idx + ' Enter Test'"
                        >
                          Enter<i class="fa fa-arrow-right marginLeft8"></i>
                        </button>

                        <button
                          v-if="
                            ['ongoing', 'paused'].includes(model.status) &&
                              !isTestCompleted(model) &&
                              model.type == 'prework'
                          "
                          class="btn btn-outline-default"
                          @click="startTest(model)"
                          :aria-label="'row ' + idx + ' View Prework'"
                        >
                          <i class="fa fa-arrow-right marginRight8"></i>View Prework
                        </button>
                        <button
                          v-if="
                            ['not started', 'scheduled'].includes(
                              model.status
                            ) && model.allowStudentsToPreviewQuestions
                          "
                          class="btn btn-outline-default"
                          @click="startTest(model, true)"
                          :aria-label="'row ' + idx + ' Preview Questions'"
                        >
                          <i class="fa fa-eye marginRight8"></i>Preview Questions
                        </button>

                        <button
                          v-if="
                            isTestCompleted(model) &&
                              model.allowStudentsToViewAnswer
                          "
                          class="btn btn-outline-default"
                          @click="startTest(model)"
                          :aria-label="'row ' + idx + ' View My Answers'"
                        >
                          <i class="fa fa-eye marginRight8"></i>View My Answers
                        </button>
                        <button
                          v-if="
                            ([
                              'irat',
                              'trat',
                              'evaluation',
                              'michaelsenEvaluation',
                            ].includes(model.type) ||
                              (model.type == 'application' &&
                                model.others.isApplicationGraded)) &&
                              (['completed', 'ended'].includes(
                                model.status
                              ) ||
                                isTestCompleted(model)) &&
                              model.allowStudentsToViewScore
                          "
                          class="btn btn-outline-default"
                          @click="viewReport(model)"
                          :aria-label="'row ' + idx + ' View My Scores'"
                        >
                          <i class="fa fa-eye marginRight8"></i>View My Scores
                        </button>
                        <template
                          v-if="
                            model.type == 'application' &&
                              !['not started', 'scheduled'].includes(
                                model.status
                              )
                          "
                        >
                          <router-link
                            v-if="model.presentationMode"
                            :to="{
                              name: 'tests.discussion',
                              params: {
                                id: model.testStudent.uuid,
                              },
                            }"
                            tag="button"
                            class="btn btn-success"
                            :aria-label="
                              !['cancelled', null].includes(
                                  model.eGalleryWalkStatus
                                ) ? 'row ' + idx + 'Join e-Gallery Walk' : 'row ' + idx + 'Join Discussion'
                            "
                            :disabled="lapsed"
                          >
                            <template
                              v-if="
                                !['cancelled', null].includes(
                                  model.eGalleryWalkStatus
                                )
                              "
                            >
                              Join e-Gallery Walk<i class="fa fa-arrow-right marginLeft8"></i>
                            </template>
                            <template v-else> 
                              Join Discussion<i class="fa fa-arrow-right marginLeft8"></i> 
                            </template>
                          </router-link>
                        </template>
                        <template
                          v-if="
                            model.type == 'trat' &&
                              [
                                'ongoing',
                                'paused',
                                'completed',
                                'ended',
                              ].includes(model.status) &&
                              model.settings.allowTeamClarifications &&
                              model.allowStudentsToViewAnswer
                          "
                        >
                          <router-link
                            :to="{
                              name: 'tests.clarification',
                              params: {
                                id: model.testStudent.uuid,
                              },
                            }"
                            tag="button"
                            class="btn btn-success"
                            :aria-label="
                              'row ' + idx + ' View Clarifications'
                            "
                            :disabled="lapsed"
                          >
                            View Clarifications<i class="fa fa-arrow-right marginLeft8"></i> 
                          </router-link>
                        </template>
                      </div> -->
                      <div class="studentIndexGrid">
                        <div>
                          <div
                            class="dropdown"
                            :class="{
                              dropup:
                                idx + 1 == testSearchData.data.data.length,
                            }"
                          >
                            <button
                              id="viewDropdownMenuButton"
                              class="btn"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="true"
                              @click="dropdownToggle"
                            >
                              View
                              <i
                                class="fa fa-caret-down marginLeft8"
                                aria-hidden="true"
                              ></i>
                            </button>
                            <div
                              class="dropdown-menu dropdown-menu-right dropdown-menu-new"
                            >
                              <ul class="testULLength">
                                <template v-if="model.type != 'prework'">
                                  <li>
                                    <router-link
                                      :to="{
                                        name: 'tests.instruction',
                                        params: {
                                          id: model.testStudent.uuid,
                                        },
                                      }"
                                      class="default-state"
                                      aria-label="View Instructions"
                                    >
                                      <span>
                                        <i
                                          class="fas fa-book marginRight8"
                                          aria-hidden="true"
                                        ></i
                                        >Instruction
                                      </span>
                                    </router-link>
                                  </li>
                                </template>

                                <template
                                  v-if="
                                    ['ongoing', 'paused'].includes(
                                      model.status
                                    ) &&
                                      !isTestCompleted(model) &&
                                      model.type == 'prework'
                                  "
                                >
                                  <li>
                                    <a
                                      class="default-state"
                                      href="#"
                                      @click="startTest(model)"
                                      aria-label="View Prework"
                                    >
                                      <span>
                                        <i
                                          class="fa fa-book marginRight8"
                                          aria-hidden="true"
                                        ></i
                                        >Prework
                                      </span>
                                    </a>
                                  </li>
                                </template>

                                <template
                                  v-if="
                                    ['not started', 'scheduled'].includes(
                                      model.status
                                    ) && model.allowStudentsToPreviewQuestions
                                  "
                                >
                                  <li>
                                    <a
                                      class="default-state"
                                      href="#"
                                      @click="startTest(model, true)"
                                      aria-label="Preview Questions"
                                    >
                                      <span>
                                        <i
                                          class="fas fa-eye marginRight8"
                                          aria-hidden="true"
                                        ></i
                                        >Preview Questions
                                      </span>
                                    </a>
                                  </li>
                                </template>

                                <template
                                  v-if="
                                    isTestCompleted(model) &&
                                      model.allowStudentsToViewAnswer
                                  "
                                >
                                  <li>
                                    <a
                                      class="default-state"
                                      href="#"
                                      @click="startTest(model)"
                                      aria-label="View My Answers"
                                    >
                                      <span>
                                        <i
                                          class="fas fa-eye marginRight8"
                                          aria-hidden="true"
                                        ></i
                                        >My Answers
                                      </span>
                                    </a>
                                  </li>
                                </template>

                                <template
                                  v-if="
                                    ([
                                      'irat',
                                      'trat',
                                      'evaluation',
                                      'michaelsenEvaluation',
                                    ].includes(model.type) ||
                                      (model.type == 'application' &&
                                        model.others.isApplicationGraded)) &&
                                      (['completed', 'ended'].includes(
                                        model.status
                                      ) ||
                                        isTestCompleted(model)) &&
                                      model.allowStudentsToViewScore
                                  "
                                >
                                  <li>
                                    <a
                                      class="default-state"
                                      href="#"
                                      @click="viewReport(model)"
                                      aria-label="View My Scores"
                                    >
                                      <span>
                                        <i
                                          class="fas fa-chart-bar marginRight8"
                                          aria-hidden="true"
                                        ></i
                                        >My Scores
                                      </span>
                                    </a>
                                  </li>
                                </template>

                                <!-- <template
                                  v-if="
                                    model.type == 'application' &&
                                      !['not started', 'scheduled'].includes(
                                        model.status
                                      ) &&
                                      model.presentationMode
                                  "
                                >
                                  <li>
                                    <router-link
                                      :to="{
                                        name: 'tests.discussion',
                                        params: {
                                          id: model.testStudent.uuid,
                                        },
                                      }"
                                      class="success-state"
                                      :class="{ disabled: lapsed }"
                                      :aria-label="
                                        !['cancelled', null].includes(
                                            model.eGalleryWalkStatus
                                          ) ? 'Join e-Gallery Walk' : 'Join Discussion'
                                      "
                                      v-tooltip="{
                                        content: !['cancelled', null].includes(
                                            model.eGalleryWalkStatus
                                          ) ? 'Join e-Gallery Walk' : 'Join Discussion',
                                      }"
                                    >
                                      <i class="fas fa-chalkboard-teacher"></i
                                      >&nbsp;
                                      <template
                                        v-if="
                                          !['cancelled', null].includes(
                                            model.eGalleryWalkStatus
                                          )
                                        "
                                      >
                                        Join e-Gallery Walk
                                      </template>
                                      <template v-else>
                                        Join Discussion
                                      </template>
                                    </router-link>
                                  </li>
                                </template>

                                <template
                                  v-if="
                                    model.type == 'trat' &&
                                      [
                                        'ongoing',
                                        'paused',
                                        'completed',
                                        'ended',
                                      ].includes(model.status) &&
                                      model.allowStudentsToViewAnswer
                                  "
                                >
                                  <li>
                                    <router-link
                                      :to="{
                                        name: 'tests.clarification',
                                        params: {
                                          id: model.testStudent.uuid,
                                        },
                                      }"
                                      class="primary-state"
                                      :class="{ disabled: lapsed }"
                                      aria-label="View Clarifications"
                                      v-tooltip="'View Clarifications'"
                                    >
                                      <i class="fas fa-chalkboard-teacher"></i
                                      >&nbsp;View Clarifications
                                    </router-link>
                                  </li>
                                </template> -->
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div class="hidden-xs hidden-sm flexOnly">
                          <template
                            v-if="
                              [
                                'not started',
                                'scheduled',
                                'ongoing',
                                'paused',
                              ].includes(model.status) &&
                                !isTestCompleted(model) &&
                                model.type != 'prework'
                            "
                          >
                            <template
                              v-if="
                                model.settings.type == 'asynchronous' &&
                                  model.settings.hasTimeLimit
                              "
                            >
                              <button
                                class="btn btn-success marginLeft32px"
                                @click="openAsyncModal(model)"
                                :disabled="lapsed"
                                :aria-label="'row ' + idx + ' Enter Activity'"
                              >
                                Enter<i
                                  class="fa fa-arrow-right marginLeft8"
                                  aria-hidden="true"
                                ></i>
                              </button>
                            </template>
                            <template v-else>
                              <button
                                class="btn btn-success marginLeft32px"
                                @click="openLoadingModal(model)"
                                :disabled="lapsed"
                                :aria-label="'row ' + idx + ' Enter Activity'"
                              >
                                Enter<i
                                  class="fa fa-arrow-right marginLeft8"
                                  aria-hidden="true"
                                ></i>
                              </button>
                            </template>
                          </template>
                          <template
                            v-if="
                              model.type == 'application' &&
                                !['not started', 'scheduled'].includes(
                                  model.status
                                )
                            "
                          >
                            <router-link
                              v-if="model.presentationMode"
                              :to="{
                                name: 'tests.discussion',
                                params: {
                                  id: model.testStudent.uuid,
                                },
                              }"
                              tag="button"
                              class="btn btn-outline-success marginLeft32px"
                              :aria-label="
                                !['cancelled', null].includes(
                                  model.eGalleryWalkStatus
                                )
                                  ? 'Join e-Gallery Walk'
                                  : 'Join Discussion'
                              "
                              :disabled="lapsed"
                            >
                              <template
                                v-if="
                                  !['cancelled', null].includes(
                                    model.eGalleryWalkStatus
                                  )
                                "
                              >
                                <i
                                  class="fa-solid fa-check-to-slot marginRight8"
                                  aria-hidden="true"
                                ></i
                                >Join e-Gallery Walk
                              </template>
                              <template v-else>
                                <i
                                  class="fas fa-chalkboard-teacher marginRight8"
                                  aria-hidden="true"
                                ></i
                                >Join Discussion
                              </template>
                            </router-link>
                          </template>

                          <template
                            v-if="
                              model.type == 'trat' &&
                                [
                                  'ongoing',
                                  'paused',
                                  'completed',
                                  'ended',
                                ].includes(model.status) &&
                                model.settings.allowTeamClarifications &&
                                model.allowStudentsToViewAnswer
                            "
                          >
                            <router-link
                              :to="{
                                name: 'tests.clarification',
                                params: {
                                  id: model.testStudent.uuid,
                                },
                              }"
                              tag="button"
                              class="btn btn-outline-success marginLeft32px"
                              :aria-label="' Join Clarifications'"
                              :disabled="lapsed"
                            >
                              <i
                                class="fas fa-hand-paper marginRight8"
                                aria-hidden="true"
                              ></i
                              >Join Clarifications
                            </router-link>
                          </template>
                        </div>

                        <div class="hidden-md hidden-lg flexOnly">
                          <template
                            v-if="
                              [
                                'not started',
                                'scheduled',
                                'ongoing',
                                'paused',
                              ].includes(model.status) &&
                                !isTestCompleted(model) &&
                                model.type != 'prework'
                            "
                          >
                            <template
                              v-if="
                                model.settings.type == 'asynchronous' &&
                                  model.settings.hasTimeLimit
                              "
                            >
                              <button
                                class="btn btn-success marginLeft32px"
                                @click="openAsyncModal(model)"
                                :disabled="lapsed"
                                :aria-label="'Enter Activity'"
                              >
                                <i
                                  class="fa fa-arrow-right"
                                  aria-hidden="true"
                                ></i>
                              </button>
                            </template>
                            <template v-else>
                              <button
                                class="btn btn-success marginLeft32px"
                                @click="openLoadingModal(model)"
                                :disabled="lapsed"
                                :aria-label="'Enter Activity'"
                              >
                                <i
                                  class="fa fa-arrow-right"
                                  aria-hidden="true"
                                ></i>
                              </button>
                            </template>
                          </template>

                          <template
                            v-if="
                              model.type == 'application' &&
                                !['not started', 'scheduled'].includes(
                                  model.status
                                )
                            "
                          >
                            <router-link
                              v-if="model.presentationMode"
                              :to="{
                                name: 'tests.discussion',
                                params: {
                                  id: model.testStudent.uuid,
                                },
                              }"
                              tag="button"
                              class="btn btn-outline-success marginLeft32px"
                              :aria-label="
                                !['cancelled', null].includes(
                                  model.eGalleryWalkStatus
                                )
                                  ? 'Join e-Gallery Walk'
                                  : 'Join Discussion'
                              "
                              :disabled="lapsed"
                              v-tooltip="{
                                content: !['cancelled', null].includes(
                                  model.eGalleryWalkStatus
                                )
                                  ? 'Join e-Gallery Walk'
                                  : 'Join Discussion',
                              }"
                            >
                              <template
                                v-if="
                                  !['cancelled', null].includes(
                                    model.eGalleryWalkStatus
                                  )
                                "
                              >
                                <i
                                  class="fa-solid fa-check-to-slot"
                                  aria-hidden="true"
                                ></i>
                              </template>
                              <template v-else>
                                <i
                                  class="fas fa-chalkboard-teacher"
                                  aria-hidden="true"
                                ></i>
                              </template>
                            </router-link>
                          </template>

                          <template
                            v-if="
                              model.type == 'trat' &&
                                [
                                  'ongoing',
                                  'paused',
                                  'completed',
                                  'ended',
                                ].includes(model.status) &&
                                model.settings.allowTeamClarifications &&
                                model.allowStudentsToViewAnswer
                            "
                          >
                            <router-link
                              :to="{
                                name: 'tests.clarification',
                                params: {
                                  id: model.testStudent.uuid,
                                },
                              }"
                              tag="button"
                              class="btn btn-outline-success marginLeft32px"
                              :aria-label="'Join Clarifications'"
                              :disabled="lapsed"
                              v-tooltip="{ content: 'Join Clarifications' }"
                            >
                              <i
                                class="fas fa-hand-paper"
                                aria-hidden="true"
                              ></i>
                            </router-link>
                          </template>
                        </div>

                        <!-- <button
                              v-if="
                                [
                                  'not started',
                                  'scheduled',
                                  'ongoing',
                                  'paused',
                                ].includes(model.status) &&
                                  !isTestCompleted(model) &&
                                  model.type != 'prework'
                              "
                              class="btn btn-success"
                              @click="startTest(model)"
                              aria-label="Enter"
                              :disabled="lapsed"
                            >
                              <i class="fa fa-caret-right"></i>
                            </button>

                            <button
                              v-if="
                                ['ongoing', 'paused'].includes(
                                  model.status
                                ) &&
                                  !isTestCompleted(model) &&
                                  model.type == 'prework'
                              "
                              class="btn btn-primary"
                              @click="startTest(model)"
                              aria-label="View Prework"
                            >
                              <i class="fa fa-book"></i>
                            </button>

                            <button
                              v-if="
                                ['not started', 'scheduled'].includes(
                                  model.status
                                ) && model.allowStudentsToPreviewQuestions
                              "
                              class="btn btn-primary"
                              @click="startTest(model, true)"
                              aria-label="Preview Questions"
                            >
                              <i class="fa fa-eye"></i>
                            </button>
                            <button
                              v-if="
                                isTestCompleted(model) &&
                                  model.allowStudentsToViewAnswer
                              "
                              class="btn btn-primary"
                              @click="startTest(model)"
                              aria-label="View My Answers"
                            >
                              <i class="fa fa-eye"></i>
                            </button>
                            <button
                              v-if="
                                ([
                                  'irat',
                                  'trat',
                                  'evaluation',
                                  'michaelsenEvaluation',
                                ].includes(model.type) ||
                                  (model.type == 'application' &&
                                    model.others.isApplicationGraded)) &&
                                  (['completed', 'ended'].includes(
                                    model.status
                                  ) ||
                                    isTestCompleted(model)) &&
                                  model.allowStudentsToViewScore
                              "
                              class="btn btn-primary"
                              @click="viewReport(model)"
                              aria-label="View My Scores"
                            >
                              <i class="fas fa-chart-bar"></i>
                            </button> -->
                        <!-- <template
                              v-if="
                                model.type == 'application' &&
                                  !['not started', 'scheduled'].includes(
                                    model.status
                                  ) &&
                                  model.allowStudentsToViewAnswer
                              "
                            >
                              <router-link
                                v-if="model.presentationMode"
                                :to="{
                                  name: 'tests.discussion',
                                  params: {
                                    id: model.testStudent.uuid,
                                  },
                                }"
                                tag="button"
                                class="btn btn-outline-default"
                                aria-label="Join Discussion"
                                :disabled="lapsed"
                              >
                                <i class="fas fa-chalkboard-teacher"></i>
                              </router-link>
                            </template> -->
                        <!--)&&model.canStartTrat%2==1-->
                        <!-- <template
                              v-if="
                                model.type == 'trat' &&
                                  [
                                    'ongoing',
                                    'paused',
                                    'completed',
                                    'ended',
                                  ].includes(model.status) &&
                                  model.allowStudentsToViewAnswer
                              "
                            >
                              <router-link
                                :to="{
                                  name: 'tests.clarification',
                                  params: {
                                    id: model.testStudent.uuid,
                                  },
                                }"
                                tag="button"
                                class="btn btn-outline-default"
                                aria-label="View Clarifications"
                                :disabled="lapsed"
                              >
                                <i class="fas fa-chalkboard-teacher"></i>
                              </router-link>
                            </template> -->
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </template>
      </kr-search>
    </div>

    <div
      class="modal"
      id="loadingScreenModal"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      role="dialog"
      aria-labelledby="loadingScreenModal-title"
    >
      <div class="modal-dialog blue-modal-new">
        <div class="modal-content">
          <div class="modal-body textAlignCenter">
            <div class="marginBottom20">
              <h1>Remember to save your answer</h1>
              <p class="loadingAnimation">Loading</p>
            </div>

            <img
              src="/video/desktop_loading_screen_finalize.gif"
              alt="step 1 select answer step 2 tap save answer button below step 3 save answer button transitions to Next button"
              width="100%"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal warning-modal"
      :class="{ isStudent: auth.user().role == 'Student' }"
      id="asyncMessageModal"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      role="dialog"
      aria-labelledby="asyncMessageModal-title"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close Modal"
            >
              <i class="fa-solid fa-xmark" aria-hidden="true"></i>
            </button>

            <h1 id="asyncMessageModal-title" class="modal-title">
              Important
            </h1>
          </div>

          <div class="modal-body textAlignCenter">
            <h1 class="textAlignCenter">
              This activity has a designated time limit
            </h1>

            <p
              v-if="isTest != ''"
              class="textAlignCenter fw-normal marginBottom30"
            >
              <b
                >Time Limit:
                <span class="timer">
                  {{ isTest.settings.durationDays }} Day(s)
                  {{ isTest.settings.durationHours }} Hour(s)
                  {{ isTest.settings.durationMinutes }} Minute(s)
                </span>
              </b>
            </p>

            <img src="/img/warning.png" width="10%" alt="warning icon" />

            <p class="textAlignCenter fw-normal">
              You may start this asynchronous activity anytime.
            </p>

            <p class="textAlignCenter fw-normal marginBottom40">
              <b class="important"
                >However you must complete within the time limit.</b
              >
            </p>

            <p class="textAlignCenter fw-normal">
              <b>The timer will start instantly.</b>
            </p>

            <p class="textAlignCenter fw-normal marginBottom30 fs-16">
              If you are ready to begin, click the “Yes, start activity” button.
              <br />
              Otherwise, you may choose to cancel.
            </p>

            <p>
              <i>Remember to manage your time effectively.</i>
              <br />
              <i>Good luck!</i>
            </p>
          </div>

          <div class="modal-footer bg-white padding20 paddingTop10">
            <button
              class="btn btn-outline-default"
              data-dismiss="modal"
              aria-label="No, come back later"
            >
              No, come back later
            </button>

            <button
              class="btn btn-success"
              @click.prevent="openLoadingModal(isTest)"
              data-dismiss="modal"
              aria-label="Yes, start activity"
            >
              Yes, start activity
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import KrAuth from "../../../components/auth/auth";
export default {
  data() {
    var auth = new KrAuth();
    var that = this;
    return {
      auth: auth,
      isBusy: false,
      testSearchData: {
        meta: { paginator: { total: 0 } },
        data: { data: { data: [] } },
        query: { isTrashed: "0" },
      },
      accessibility: {
        selectedRow: false,
        selectedButton: false,
      },
      query_fields: { isArchived: "0" },
      documentTitle: document.title,
      isTest: "",
    };
  },
  created() {
    Events.fire("topbar_update", {
      title: '<i class="fas fa-pencil-ruler"></i>&nbsp;Activities',
      breadcrumb: [{ name: "Home" }, { name: "Activities" }],
    });
  },
  methods: {
    sortByModule(data) {
      let m = [];
      for (var i = 0; i < data.length; i++) {
        let idx = _.findIndex(m, function(o) {
          return o.uuid == data[i].module.uuid;
        });
        if (idx == -1) {
          let c = _.clone(data[i].module);
          c.tests = [];
          c.tests.push(_.clone(data[i]));
          m.push(c);
        } else {
          m[idx].tests.push(data);
        }
      }
      return m;
    },
    getTestData(data) {
      this.testSearchData = data.data;
      let modules = this.testSearchData.data.data;
      for (var i = modules.length - 1; i >= 0; i--) {
        let module = modules[i];
        for (var j = module.activities.length - 1; j >= 0; j--) {
          let activity = module.activities[j];
          if (activity.tests.length == 0) {
            module.activities.splice(j, 1);
          }
        }
        if (module.activities.length == 0) {
          modules.splice(i, 1);
        }
      }
      this.sortByTimeStarted();
    },
    sortByTimeStarted() {
      let modules = this.testSearchData.data.data;
      for (var i = modules.length - 1; i >= 0; i--) {
        let module = modules[i];
        for (var j = 0; j < module.activities.length; j++) {
          let activity = module.activities[j];
          for (var k = 0; k < activity.tests.length; k++) {
            if (!module._timeStarted) {
              module._timeStarted = 1;
            }
            if (activity.tests[k].timeStarted) {
              if (module._timeStarted) {
                if (module._timeStarted < activity.tests[k].timeStarted) {
                  module._timeStarted = activity.tests[k].timeStarted;
                }
              } else {
                module._timeStarted = activity.tests[k].timeStarted;
              }
            }
          }
        }
      }
      this.testSearchData.data.data = _.orderBy(
        this.testSearchData.data.data,
        ["_timeStarted"],
        ["desc"]
      );
    },
    isTestEntered(test) {
      return ["entered"].includes(
        _.get(test, "testStudent.myProgression.userTestStatus")
      );
    },
    isTestStarted(test) {
      return ["started", "ongoing"].includes(
        _.get(test, "testStudent.myProgression.userTestStatus")
      );
    },
    isTestCompleted(test) {
      if (
        ["completed", "ended"].includes(test.status) ||
        ["finished", "incomplete"].includes(
          _.get(test, "testStudent.myProgression.userTestStatus")
        )
      ) {
        return true;
      }
      return false;
    },
    startTest(test, isPreview = false) {
      var processTest = function() {
        if (!isPreview) {
          if (test.type == "prework") {
            this.$router.push({
              name: "tests.prework",
              params: { id: test.testStudent.uuid },
            });
          }
          if (test.type == "irat") {
            this.$router.push({
              name: "tests.proper",
              params: { id: test.testStudent.uuid },
            });
          }
          if (test.type == "trat") {
            this.$router.push({
              name: "tests.proper",
              params: { id: test.testStudent.uuid },
            });
          }
          if (test.type == "application") {
            this.$router.push({
              name: "tests.proper",
              params: { id: test.testStudent.uuid },
            });
          }
          if (
            test.type == "evaluation" ||
            test.type == "michaelsenEvaluation"
          ) {
            this.$router.push({
              name: "tests.evaluation",
              params: { id: test.testStudent.uuid },
            });
          }
        } else {
          if (["irat", "trat", "application"].includes(test.type)) {
            this.$router.push({
              name: "tests.preview.rat",
              params: { id: test.testStudent.uuid },
            });
          } else if (test.type == "evaluation") {
            this.$router.push({
              name: "tests.preview.evaluation",
              params: { id: test.testStudent.uuid },
            });
          }
        }
      }.bind(this);
      //console.log(test);
      if (isPreview || test.type == "prework") {
        processTest();
      } else if (
        ["not started", "scheduled"].includes(test.status) &&
        !_.get(test, "settings.allowSafeExamBrowserOnly")
      ) {
        axios
          .put("student/tests/" + test.testStudent.uuid + "/enter")
          .then(function() {
            processTest();
          });
      } else {
        /*else if(['ongoing'].includes(test.status)&&!this.isTestStarted(test)){
                axios.put('student/tests/'+test.uuid+'/start').then(function(){
                    processTest();
                })
            }*/
        processTest();
      }
    },
    viewReport(test) {
      if (test.type == "irat") {
        this.$router.push({
          name: "tests.irat-report",
          params: { id: test.testStudent.uuid },
        });
      } else if (test.type == "trat") {
        this.$router.push({
          name: "tests.trat-report",
          params: { id: test.testStudent.uuid },
        });
      } else if (test.type == "application") {
        this.$router.push({
          name: "tests.application-report",
          params: { id: test.testStudent.uuid },
        });
      } else if (
        test.type == "evaluation" ||
        test.type == "michaelsenEvaluation"
      ) {
        this.$router.push({
          name: "tests.evaluation-report",
          params: { id: test.testStudent.uuid },
        });
      }
    },
    getDueDate(test) {
      if (
        test.type == "prework" ||
        test.type == "evaluation" ||
        test.type == "michaelsenEvaluation"
      ) {
        let endDate = _.get(test, "settings.endDate");
        if (endDate) {
          return (
            this.convertToReadableDate(endDate, "DD MMM YYYY, hh:mm a").date +
            " (" +
            this.convertToReadableDate(endDate, "DD MMM YYYY, hh:mm a")
              .current_timezone +
            ")"
          );
        } else {
          return "";
        }
      } else "";
    },
    getStudentTestStatus(test) {
      return _.get(
        test,
        "testStudent.myProgression.userTestStatus",
        "not started"
      );
    },
    searchModule() {
      Events.fire("activities_listing_refresh");
    },
    dropdownToggle() {
      if ($("table tbody tr").length >= 6) {
        $(".dropdown").addClass("dropup");
      } else if ($("table tbody tr").length == 5) {
        $(".dropdown").addClass("dropup");
      }
    },
    openLoadingModal(test) {
      var that = this;

      if (
        ["not started", "scheduled"].includes(test.status) &&
        !_.get(test, "settings.allowSafeExamBrowserOnly")
      ) {
        this.startTest(test);
      } else {
        if (
          test.testStudent.myProgression.userTestStatus == null &&
          !["evaluation", "michaelsenEvaluation"].includes(test.type)
        ) {
          $("#loadingScreenModal").modal("show");

          window.setTimeout(function() {
            $("#loadingScreenModal").modal("hide");
            that.startTest(test);
          }, 4100);
        } else {
          this.startTest(test);
        }
      }
    },
    openAsyncModal(test) {
      this.isTest = test;

      if (
        ["not started", "scheduled"].includes(test.status) &&
        !_.get(test, "settings.allowSafeExamBrowserOnly")
      ) {
        this.startTest(test);
      } else {
        if (test.testStudent.myProgression.userTestStatus == null) {
          $("#asyncMessageModal").modal("show");
        } else {
          this.startTest(test);
        }
      }
    },
  },
  mounted() {
    document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        $(".new-studentTest-index-table").each(function(i, obj) {
          $(this)
            .find(".test-listing-row")
            .each(function(j, object) {
              if ($(object).find(".testULLength li").length > 0) {
                $(object)
                  .find(".dropdown")
                  .show();
              } else {
                $(object)
                  .find(".dropdown")
                  .hide();
              }
            });
        });
      }
    };
  },
  computed: {
    lapsed() {
      //return false;
      if (
        ["Lapsed", "Expired"].includes(this.auth.user().status) &&
        this.auth.user().account.paymentMethod == "Student-Paid"
      ) {
        return true;
      }
      return false;
    },
  },
  watch: {
    documentTitle: {
      immediate: true,
      handler() {
        var tabName =
          this.query_fields.isArchived == 0
            ? "Active"
            : this.query_fields.isArchived == 1
            ? "Archived"
            : "";
        document.title = `Activities | ${tabName} | InteDashboard | TBL Makes Teams Work`;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.test-listing-row.selected {
  background-color: rgba(0, 255, 0, 0.3);
}
.btn.selected {
  background-color: yellow !important;
  color: black !important;
}

.new-studentTest-index-table {
  margin-bottom: 30px;
  overflow: auto;
}

// @media (min-width: 992px) {
//   .btn {
//     margin-left: 0;
//   }
// }

.studentIndexGrid {
  // display: grid;
  // grid-template-columns: 317px 133px;
  // grid-template-columns: 100px 217px 133px;
  // text-align: right;
  display: flex;
  // justify-content: end;
  align-items: center;

  .btn {
    flex: auto;
  }
}

// @media (max-width: 992px) {
//   .studentIndexGrid {
//     grid-template-columns: 121px 130px;
//   }
// }

.marginLeft32px {
  margin-left: 32px;
}
.marginRight32px {
  margin-right: 32px;
}
</style>
